import { render } from "./Plato.vue?vue&type=template&id=7754c8ef"
import script from "./Plato.vue?vue&type=script&lang=js"
export * from "./Plato.vue?vue&type=script&lang=js"
script.render = render

export default script